import actionTypes from '../constants/action-types';

const exportSite = (siteId, options = {}) => {
  const { onSuccess = Function.prototype, onFail = Function.prototype, ...opts } = options;

  return {
    type: actionTypes.EXPORT_SITE,
    payload: {
      siteId,
      onSuccess,
      onFail,
      options: opts,
    },
  };
};

export default exportSite;
